{
  "fr": {
    "baseChip": {
      "states": {
        "included": "inclus",
        "excluded": "exclu"
      },
      "sortHint": "Utilisez les flèches du clavier pour déplacer"
    }
  }
}
